import React from 'react'

export const aboutMe: React.ReactNode = (
  <>
    <p style={{ textAlign: 'start' }}>
      <p>
        Full-Stack developer with over 5 years of experience developing web applications of varying complexity,
        delivering high-quality UI/UX projects with modern web design.
        Web application development is carried out using cutting-edge technology stacks.
      </p>
      <br/>
      <p style={{display: 'flex', justifyContent: 'center'}}>
        Full-Stack Development:
      </p>
      <br/>
      <p>
        Frontend:
      </p>
      <p>
        React, Next.js, TypeScript, Redux Toolkit, Zustand, TanStack Query, CSS/SCSS/SASS.
      </p>
      <br/>
      <p>
        Backend:
      </p>
      <p>
        Node.js (Express, NestJS), REST API, GraphQL.
      </p>
      <br/>
      <p>
        Databases:
      </p>
      <p>
        PostgreSQL (Prisma ORM), MongoDB.
      </p>
      <br/>
      <p>
        Infrastructure:
      </p>
      <p>
        Docker, CI/CD pipelines, cloud platforms (AWS, Vercel).
      </p>
      <br/>
      <p style={{display: 'flex', justifyContent: 'center'}}>
        Cross-Functional Skills:
      </p>
      <br/>
      <p>
        Responsive and Cross-Browser Layouts: Ensuring seamless display across all devices and browsers.
      </p>
      <br/>
      <p>
        SEO Optimization: Improving page load speed, implementing meta tags, and Schema.org microdata for better search
        engine visibility.
      </p>
      <br/>
      <p>
        Performance Optimization: Enhancing rendering efficiency, implementing lazy loading, and leveraging caching
        mechanisms to boost application speed.
      </p>
    </p>
  </>
)

export const aboutMeRus: React.ReactNode = (
<>
  Инженер-программист с более чем 5-летним опытом создания веб приложений различной сложности,
  представляющий высококачественные UI/UX-проекты с современным веб-дизайном.
  Разработка веб приложений осуществляется с использоанием современного стэка технологий.

  Комплексная разработка:

  Фронтенд: React, Next.js, TypeScript, Redux Toolkit, Zustand, TanStack Query, современный CSS/SCSS.
  Бэкенд: Node.js (Express, NestJS), REST API, GraphQL.
  Базы данных: PostgreSQL (Prisma ORM), MongoDB.
  Инфраструктура: Docker, CI/CD, облачные платформы (AWS, Vercel).

  Кросс-функциональные навыки:

  Адаптивная и кросс-браузерная верстка.
  SEO-оптимизация: улучшение скорости загрузки, метатеги, микроразметка Schema.org.
  Производительность: оптимизация рендеринга, ленивая загрузка, кэширование.
</>
)

export const aboutRus: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>COMMENTS - это демонстрационный фуллстек проект, созданный с целью практики
      применения следующих технологий:</p>
    <p style={{ textAlign: 'center' }}>Frontend: React, Typescript, Redux Toolkit, Tanstack Query. Backend: Express,
      Prisma ORM.</p>
    <p style={{ textAlign: 'center' }}>Функциональность проекта:</p>
    <ul style={{ marginLeft: '25px' }}>
      <li>JWT авторизация/регистрация нового пользователя.</li>
      <li>Добавление/изменение аватара пользователя с сохранением в объектном хранилище S3.</li>
      <li>Добавление/удаление пользователем комментариев либо создание комментариев автоматически.</li>
      <li>Бесконечный скролл с постепенной подгрузкой комментариев, созданных пользователем из базы данных PostgreSQL.
      </li>
      <li>Настроен CI/CD через GitHub Actions, с дальнейшим развертыанием в Docker на Linux сервере.</li>
    </ul>
    <br />
    <p style={{ textAlign: 'center' }}>Вход - name: admin, password: 123456789 либо зарегистрируйтесь в качестве нового
      пользователя.</p>
  </>
)


export const aboutEng: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>COMMENTS - is a demo full-stack project created to practice the use of the
      following technologies:</p>
    <p style={{ textAlign: 'center' }}>Frontend: React, Typescript, Redux Toolkit, Tanstack Query. Backend: Express,
      Prisma ORM.</p>
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <ul style={{ marginLeft: '25px' }}>
      <li>JWT authorization/registration of a new user.</li>
      <li>Adding/changing user`s avatar with saving in S3 cloud object storage.</li>
      <li>Adding/deleting comments by the user or creating comments automatically.</li>
      <li>Infinite scroll with gradual loading of comments created by the user from the PostgreSQL database.</li>
      <li>Created a CI/CD Pipeline with Docker and GitHub Actions.</li>
    </ul>
    <br />
    <p style={{ textAlign: 'center' }}>Login - name: admin, password: 123456789 or register as a new user.</p>
  </>
)

export const webLinks = {
  comments: 'https://comments.bunch-of-stuff.ru/',
  art: 'https://art.bunch-of-stuff.ru/',
  waterDB: 'https://water-database.bunch-of-stuff.ru/',
  dashboard: 'https://dashboard.bunch-of-stuff.ru/',
  waterShop: 'https://water-shop.bunch-of-stuff.ru/',
}

export const aboutComments: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>Full-stack project with using technologies:</p>
    <br />
    <p style={{ marginLeft: '25px' }}>Frontend: React, Typescript, Redux Toolkit, Tanstack Query.</p>
    <p style={{ marginLeft: '25px' }}>Backend: Express, Prisma ORM.</p>
    <br />
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <br />
    <ul style={{ marginLeft: '25px' }}>
      <li>JWT authorization/registration of a new user.</li>
      <li>Adding/changing user`s avatar with saving in S3 cloud object storage.</li>
      <li>Adding/deleting comments by the user or creating comments automatically using Faker API.</li>
      <li>Infinite scroll with gradual loading of comments created by the user from the PostgreSQL database.</li>
      <li>Created a CI/CD Pipeline with Docker and GitHub Actions.</li>
    </ul>
  </>
)

export const aboutArt: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>Static website about World Art with using Next.js 13</p>
    {/*<br/>*/}
    {/*<p style={{marginLeft: '25px'}}>Frontend: React, Typescript, Redux Toolkit, Tanstack Query.</p>*/}
    {/*<p style={{marginLeft: '25px'}}>Backend: Express, Prisma ORM.</p>*/}
    <br />
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <br />
    <ul style={{ marginLeft: '25px' }}>
      <li>World Art project currently is a prototype for a future website about world art,
        in particular about world museums and their collections.
      </li>
      <li>The examples presented include items with descriptions from the collections
        of the British Museum, the Louvre, the Galleria Borghese, the Hermitage and the Vatican Museums.
      </li>
    </ul>
  </>
)

export const aboutWaterDB: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>Full-stack project with using technologies:</p>
    <br />
    <p style={{ marginLeft: '25px' }}>Frontend: React, Typescript, Redux Toolkit.</p>
    <p style={{ marginLeft: '25px' }}>Backend: Express, Prisma ORM.</p>
    <br />
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <br />
    <ul style={{ marginLeft: '25px' }}>
      <li>The database of products of a trading company specializing in wholesale supplies of food products,
        in particular mineral water.
      </li>
      <li>JWT authorization/registration of a new employee.</li>
      <li> Creating a product card with a description and saving in PostgreSQL Database.</li>
      <li> Edit/Delete a product card with access rights.
        The employee can view product cards created by other employees, but cannot edit or delete them.
      </li>
    </ul>
  </>
)

export const aboutDashboard: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>Admin dashboard panel with using technologies:</p>
    <br />
    <p style={{ textAlign: 'center' }}>React, Redux, Firebase.</p>
    <br />
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <br />
    <ul style={{ marginLeft: '25px' }}>
      <li>Admin Dashboard panel allows you to create users, products, orders with saving in Firebase.</li>
      <li>Static data, graphs, calendar.</li>
      <li>Change the theme to light or dark.</li>
    </ul>
  </>
)

export const aboutWaterShop: React.ReactNode = (
  <>
    <p style={{ textAlign: 'center' }}>Full-stack project with using technologies:</p>
    <br />
    <p style={{ marginLeft: '25px' }}>Frontend: Next.js, Typescript, Redux Toolkit.</p>
    <p style={{ marginLeft: '25px' }}>Backend: NestJS, PostgreSQL.</p>
    <br />
    <p style={{ textAlign: 'center' }}>Project functionality:</p>
    <br />
    <ul style={{ marginLeft: '25px' }}>

      <li>Online store selling equipment and components for fountains, reservoirs and ponds.</li>
    </ul>
    <br />
    <p style={{ textAlign: 'center' }}>...is under construction now...</p>
  </>
)